module.exports = __webpack_public_path__ + "static/media/deer.171e8cc4.jpg";